export default __webpack_public_path__ + "static/media/progressbar_1.cffa0f5b.PNG";